package it.maicol07.gamerlogue.ui.navigation.rootTree

import androidx.navigation3.runtime.NavKey
import io.github.fopwoc.nav3ksp.NavTreeLayout
import kotlinx.serialization.modules.PolymorphicModuleBuilder
import kotlinx.serialization.modules.subclass as subclass

public object RootNavTreeLayout : NavTreeLayout() {
  override fun PolymorphicModuleBuilder<NavKey>.polymorphicSerializationSubClasses() {
    subclass(serializer = RootNavTree.UserListDetail.serializer())
    subclass(serializer = RootNavTree.UserConnections.serializer())
    subclass(serializer = RootNavTree.BlockedUsers.serializer())
    subclass(serializer = RootNavTree.Notifications.serializer())
    subclass(serializer = RootNavTree.ActivityFeed.serializer())
    subclass(serializer = RootNavTree.EventList.serializer())
    subclass(serializer = RootNavTree.Calendar.serializer())
    subclass(serializer = RootNavTree.ServiceSync.serializer())
    subclass(serializer = RootNavTree.ServerSettings.serializer())
    subclass(serializer = RootNavTree.LinkedServices.serializer())
    subclass(serializer = RootNavTree.LibraryImportPreview.serializer())
    subclass(serializer = RootNavTree.Appearance.serializer())
    subclass(serializer = RootNavTree.Settings.serializer())
    subclass(serializer = RootNavTree.Profile.serializer())
    subclass(serializer = RootNavTree.UserProfile.serializer())
    subclass(serializer = RootNavTree.Login.serializer())
    subclass(serializer = RootNavTree.ReviewDetail.serializer())
    subclass(serializer = RootNavTree.ReviewEditor.serializer())
    subclass(serializer = RootNavTree.Library.serializer())
    subclass(serializer = RootNavTree.GameList.serializer())
    subclass(serializer = RootNavTree.Discover.serializer())
    subclass(serializer = RootNavTree.GameDetail.serializer())
    subclass(serializer = RootNavTree.GameReviews.serializer())
  }
}
